module.exports = __webpack_public_path__ + "a5e5de7d99a6141884367589252c4dd0.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Bold-Oblique.eot
// module id = 389
// module chunks = 0